import { render, staticRenderFns } from "./OverviewComponent.vue?vue&type=template&id=d81cd5ce&scoped=true"
import script from "./OverviewComponent.vue?vue&type=script&lang=js"
export * from "./OverviewComponent.vue?vue&type=script&lang=js"
import style0 from "./OverviewComponent.vue?vue&type=style&index=0&id=d81cd5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81cd5ce",
  null
  
)

export default component.exports